import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class RoomsStoreProvider {

	private db = new DatabaseProvider;
	public roomsList: BehaviorSubject<any> = new BehaviorSubject([]);

	constructor() {

	}

	addBatch(roomList) {

		return new Promise((resolve, reject) => {

			this.db.rooms.clear().then(() => {

				this.db.rooms.bulkAdd(roomList).then((data) => {

					resolve(data)

				}).catch((e) => reject(e));

			}).catch((e) => reject(e));

		})

	}

	loadList() {

		return new Promise((resolve, reject) => {

			this.db.rooms.toArray().then((data) => {

				let list = [];
				if (data && data.length > 0) {
					list = [...data];
				}
				this.roomsList.next(list)
				resolve(true);

			}).catch((e) => reject(e))

		})

	}

}



// WEBPACK FOOTER //
// ./src/providers/rooms-store/rooms-store.ts